import { defineComponent as _defineComponent } from 'vue'
import { InputField } from '@/ui/components/form/InputField';
  import { Modal } from '@/ui/components/Modal';
  import { LINK_PROMPT_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { Button } from '@/ui/components/Button';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LinkPromptModal',
  props: {
    initialLink: {
      type: String,
    },
  },
  emits: ['close', 'submit'],
  setup(__props, { emit }) {

const { initialLink } = __props;

  

  

  const onSubmit = () => {
    emit('submit', link.value);
  };

  const link = ref(initialLink || '');
  const updateLink = (newLink: string) => {
    link.value = newLink;
  };

return { __sfc: true,emit, onSubmit, link, updateLink, InputField, Modal, LINK_PROMPT_MODAL_WIDTH, Button, PageSubtitle }
}

})